:host {
  /* Component styles go here */
}

button {
  display: grid;
  place-items: center;
  appearance: none;
  border: none;
  height: 100%;
  width: 100%;
  background-color: $color-red-brand-01;
  padding: 0;

  &:hover {
    background-color: $color-red-brand-02;
  }

  &:focus-visible {
    outline: 2px solid $color-black;
    outline-offset: -12px;

    @include media-min(md) {
      outline-offset: -24px;
    }
  }

  dc-ui-icon {
    color: $color-white;
  }
}
